// Formata progressivamente: aplica o separador assim que o grupo fecha, para
// servir tambem como mascara de digitacao. Valor completo sai igual ao de antes.
export function CpfMask(cpf: string): string {
  if (!cpf) return cpf;

  return cpf
    .replace(/\D/g, '')
    .slice(0, 11)
    .replace(/^(\d{3})(\d)/, '$1.$2')
    .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4');
}
